import { render, staticRenderFns } from "./Turns.vue?vue&type=template&id=0561f8a0"
import script from "./Turns.vue?vue&type=script&lang=js"
export * from "./Turns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports